import React, {useEffect, useState,} from 'react';
import {useObserver,} from 'mobx-react';
import {Button, TextField} from '@material-ui/core';
import {DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE} from 'constants/pagination';
import {RequestStatus, stores,} from '../../mobx-store';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {TableCellTypes,} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {translate,} from '../../helperFunctions/translation';
import classes from './noAccess.module.scss';

import {NoAccessDTO} from "./NoAccessDTO/noAccess";
import AlertDialog from "../../components/Dialog/alertDialog";
import SnackBarComponent from "../../components/SnackBarComponent/SnackBarComponent";
import {useHistory} from "react-router";

const NoAccessWheelList: React.FC = () => {

    const history = useHistory();
    const [search, setSearch] = useState('');
    const [pageNumber, setPageNumber] = useState(DEFAULT_PAGE_NUMBER);
    const [totalNumberOfPages, setTotalNumberOfPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [activeMember, setActiveMember] = useState(0);

    const getNoAccessList = (search: string, page: number) => {

        try {
            setLoading(true)
            stores.noAccessStore.NoAccessWheelList(search, pageNumber, DEFAULT_PAGE_SIZE)
                .then((r) => {
                    setTotalNumberOfPages(Math.ceil(stores.noAccessStore.noAccessCount / DEFAULT_PAGE_SIZE));
                });
        } catch (e) {

        } finally {
            setLoading(false)
        }

    }
    const removeMemberNoAccess = async (index: number) => {
        const {
            id,
        } = stores.noAccessStore.noAccessList[index];

        setOpen(true)
        setActiveMember(id)

    }
    const tableHeaders = [
        {
            title: 'ID',
        },
        {
            title: 'Membership ID',
        },

        {
            title: 'Action',
        }
    ];
    const cellTypes: TableCellTypes[] = [
        {
            cellType: 'Text',
            key: 'id',
        },
        {
            cellType: 'Text',
            key: 'membershipId',
        },
        {
            cellType: 'Button',
            onClick: removeMemberNoAccess,
            key: 'remove',
        },
    ];


    const handleFilterClick = async () => {
        setPageNumber(DEFAULT_PAGE_NUMBER)
        await getNoAccessList(search, DEFAULT_PAGE_NUMBER)
    }
    const handleClearClick = () => {
        setSearch('')
        setPageNumber(DEFAULT_PAGE_NUMBER)
        getNoAccessList('',DEFAULT_PAGE_NUMBER)
    }

    const leftArrowClicked = async () => {
        const page = pageNumber - 1
        setPageNumber(page);
        getNoAccessList(search, page);
    };
    const confirmDelete = async () => {
        try {
            setLoading(true)
            setOpen(false)
            const res = await stores.noAccessStore.RemoveNoAccessWheelMember(activeMember)
            if (res.status === true) {
                SnackBarComponent.getInstance().openSnackbar(res.message, 5000, 'success');
                await getNoAccessList(search, pageNumber);

            } else
                SnackBarComponent.getInstance().openSnackbar(res.message, 5000, 'error');
        } catch (e) {

        } finally {
            setLoading(false)
            setOpen(false)
            setActiveMember(0)
        }

    }
    const rightArrowClicked = async () => {
        const page = pageNumber + 1;
        setPageNumber(page);
        getNoAccessList(search, page);
    };

    const getTableData = () => stores.noAccessStore.noAccessList.map(
        (NO_ACCESS_REQUEST: NoAccessDTO) => ({
            id: NO_ACCESS_REQUEST.id,
            membershipId: NO_ACCESS_REQUEST.membershipId,
            remove: 'remove',
        }),
    );
  const addNoAccess = () => {
     history.push('/no-access-wheel/new');
     };
    const getAddButton = () => ({
        title: 'Add',
        onAdd: addNoAccess,
    });
    useEffect(() => {
        (async function () {
            await getNoAccessList(search, pageNumber);
        }());
    }, []);
    return useObserver(() => (
        <>
            <div className={classes.filters}>
                <TextField
                    className={classes.input}
                    placeholder={'Search Membership ID'}
                    value={search || ""}
                    label={'Search'}

                    onChange={(text) => {
                        setSearch(text.target.value);
                    }}
                />


            </div>


            <div className={classes.filterButtons}>
                <Button color="primary" variant="contained" onClick={handleFilterClick}>
                    Filter
                </Button>

                <Button color="default" variant="contained" onClick={handleClearClick}>
                    Clear
                </Button>
            </div>
            <GeneralTableComponent
                title="Wheel Of Fortune No Access List"
                emptyMessage={translate('emptyTable')}
                tableHeader={tableHeaders}
                tableData={getTableData()}
                tableCellTypes={cellTypes}
                loading={loading}
                addButton={getAddButton()}
                loadingStatus={[
                    stores.noAccessStore.getNoAccessStatus,
                ]}
                hadPagination
                paginationAction={{
                    handleClickLeftArrow: leftArrowClicked,
                    handleClickRightArrow: rightArrowClicked,
                    pageNumber,
                    totalNumberOfPages,
                }}
            />
            <AlertDialog
                title={translate('delete')}
                content={translate('deleteAlert', {})}
                isOpen={open}
                agree={confirmDelete}
                disAgree={() => {
                    setOpen(false);
                    setActiveMember(0)
                }}
                hasActions
            />
        </>
    ));
};

export default NoAccessWheelList;
